import React, { createContext, useReducer } from "react";
import BuildingsReducer from "../reducers/buildings.reducer";
import { buildingsColumns } from "../../statics/columns";

const initialState: any = {
  mode: 'table',
  buildings: [],
  buildingsPaginated: [],
  buildingsCache: [],
  columns: buildingsColumns,
  options: {
    withExport: true,
    withPrint: true,
    withRefresh: true,
    withSort: true,
    withSearch: true,
    withSwitch:true,
    sortDirection: 'asc',
    sortColumn: 'name',
    searchString: '',
    searchColumn: 'name'
  },
  pagination: {
    currentPage: 1,
    items: 10,
    totalPages: 1
  }
};

export const BuildingsContext = createContext(initialState);
export const BuildingsProvider = ({ children }: any) => {
  const [state, dispatch] = useReducer(BuildingsReducer, initialState);

  function setViewMode(mode: string) {
    dispatch({
      type: "SET_VIEW_MODE",
      payload: { mode }
    });
  }

  function setBuildings(buildings: any[]) {
    dispatch({
      type: "SET_BUILDINGS",
      payload: { buildings }
    });
  }

  function sort(params: any) {
    dispatch({
      type: "SORT_BUILDINGS",
      payload: { params }
    });
  }

  function search(params: any) {
    dispatch({
      type: "SEARCH_BUILDINGS",
      payload: { params }
    });
  }

  function paginate(params: any) {
    dispatch({
      type: "PAGINATE_BUILDINGS",
      payload: { params }
    });
  }

  const { buildings, buildingsCache, columns, options, pagination, mode } = state;
  return (
    <BuildingsContext.Provider
      value={{
        buildings,
        buildingsCache,
        columns,
        options,
        pagination,
        mode,
        setViewMode,
        setBuildings,
        search,
        sort,
        paginate
      }}
    >
      { children }
    </BuildingsContext.Provider>
  );
};